(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('DataService', DataService);

  function DataService() {

   var service = {
        convertDate : convertDate,
        convertDateFullDate : convertDateFullDate
    };

    return service;

   function convertDate(date) {

      if (date === null || date === '') {
        return ''; // se data estiver vazia nao ha o que converter
      }

      return moment(date,'YYYYMM').format('MMMM/YYYY');

    }

    function convertDateFullDate(number) {

       if (number === null || number === '') {
         return ''; // se data estiver vazia nao ha o que converter
       }

       return moment(number).format('DD/MM/YYYY');
     }
  }

 })();
